"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.actionCreators = void 0;
exports.actionCreators = {
    requestFunction: function (pageload, uuid, version) { return function (dispatch, getState) {
        var appState = getState();
        if (appState && appState.serviceByUUIDModel && pageload == true && appState.serviceByUUIDModel.stateUUID != uuid) {
            fetch("/v1/" + uuid + "/service", {
                method: 'GET'
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                dispatch({ type: 'RECEIVE_SERVICEBYUUID', model: data, uuid: uuid, version: version });
            })
                .then(function (error) {
            });
            dispatch({ type: 'REQUEST_SERVICEBYUUID' });
        }
    }; }
};
var unloadedState = { isLoading: false, response: undefined, stateUUID: "", version: 0 };
var reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case 'REQUEST_SERVICEBYUUID':
            return {
                isLoading: false,
                stateUUID: "",
                version: 0
            };
        case 'RECEIVE_SERVICEBYUUID':
            return {
                isLoading: true,
                response: action.model,
                stateUUID: action.uuid,
                version: action.version + 1
            };
        default: return state;
    }
};
exports.reducer = reducer;
//# sourceMappingURL=ServiceByUUID.js.map